import Axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import mapper from '../mapper/mapper';

type Response<T> = T;

interface Options {
	baseURL?: string;
}

interface Config extends AxiosRequestConfig {
	map: Record<any, any>;
}

export class HTTP {
	private http: AxiosInstance;

	constructor(options?: Options) {
		this.http = Axios.create();
		this.http.interceptors.request.use(this.requestInterceptor.bind(this));
		this.http.interceptors.response.use(this.handleResponse.bind(this), this.handleError.bind(this));
		this.http.defaults.baseURL = options?.baseURL ?? '';
	}

	public get<R = any>(url: string, config?: Config): Promise<Response<R>> {
		return this.http.get(url, config);
	}

	public post<R = any>(url: string, data?: any, config?: Config): Promise<Response<R>> {
		return this.http.post(url, data, config);
	}

	public put<R = any>(url: string, data?: any, config?: Config): Promise<Response<R>> {
		return this.http.put(url, data, config);
	}

	public patch<R = any>(url: string, data?: any, config?: Config): Promise<Response<R>> {
		return this.http.patch(url, data, config);
	}

	public delete<R = any>(url: string, config?: Config): Promise<Response<R>> {
		return this.http.delete(url, config);
	}

	public head<R = any>(url: string, config?: Config): Promise<Response<R>> {
		return this.http.head(url, config);
	}

	public options<R = any>(url: string, config?: Config): Promise<Response<R>> {
		return this.http.options(url, config);
	}

	public request<R = any>(config: Config): Promise<Response<R>> {
		return this.http.request(config);
	}

	private requestInterceptor(config: AxiosRequestConfig) {
		return config;
	}

	private handleResponse(response: AxiosResponse<any>) {
		if ((response.config as Config).map) {
			return mapper.map(response.data, (response.config as Config).map);
		}

		return response?.data?.data;
	}

	private handleError(error: any) {
		return Promise.reject(error?.response?.data);
	}
}
